import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "studio-project-small",
  "use": "studio-project-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"studio-project-small\">\n  <path d=\"M5 4h3v1H5zm0 3h6v1H5zm0 2h6v1H5zm0 2h6v1H5z\" />\n  <path d=\"M12 2v12H4V2h8m1-1H3v14h10V1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol